@if(language == 'Ar'){
  <button #container class="inactive arabic" (click)="redirect(menuItemID())">
    {{LearnMore()}}
  </button>
} @else {
  <button #container class="inactive" (click)="redirect(menuItemID())">
    {{LearnMore()}}
  </button>
}

